import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { appUserSort } from '../../common/sorts';
import { InsectaServiceBase } from './insecta.base.service';
import { IAppUser, IAppUserSettings } from './insecta.models';

@Injectable({
  providedIn: 'root'
})
export class AppUserService extends InsectaServiceBase {
  public getAppUsers(includeInActive: boolean = true): Observable<IAppUser[]> {
    return this.get<IAppUser[]>(`/appusers`, `v1`).pipe(
      map((results) => [...results].filter((x) => includeInActive || x.isActive).sort(appUserSort))
    );
  }

  public getAppUserByEmail(email: string): Observable<IAppUser> {
    return this.get<IAppUser>(`/appuserbyemail/${email}`, `v1`);
  }

  public updateAppUserSettings(appUser: IAppUserSettings): Observable<IAppUser> {
    return this.put<IAppUser>(`/updateusersettings/`, `v1`, appUser);
  }
}
